module.exports = __webpack_public_path__ + "img/navlogo.be0beddb.png";